import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaExternalLinkAlt } from 'react-icons/fa';
import styled from 'styled-components';

import { SubscriptionRequestWarning } from '@/types/subscriptions/request';
import { pages, formatRoute } from '@/settings/pages';

type Props = {
  userWarnings: SubscriptionRequestWarning[];
};

export const UserWarning: React.FC<Props> = ({ userWarnings }) => {
  const { t } = useTranslation();

  return (
    <Styled>
      <ul className="user-warning">
        {userWarnings.map((warning, i) => {
          return typeof warning !== 'string' ? (
            <li key={i}>
              <div className="user-warning-anchor">
                {t('ui.warning.keyName')}
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={formatRoute(pages.subscription.detail, {
                    requestCode: warning.engagedRequestCode,
                  })}
                  className="user-warning-anchor"
                >
                  <span className="user-warning-anchor-text">
                    {warning.engagedRequestCode}
                  </span>
                  <FaExternalLinkAlt />
                </a>
              </div>
            </li>
          ) : (
            <li key={i}>{t('ui.warning.duplicatedName')}</li>
          );
        })}
      </ul>
    </Styled>
  );
};

const Styled = styled.div`
  .user-warning {
    padding-left: 2em;
    margin: 0;
    color: brown;
    font-size: 0.8em;
  }

  .user-warning-anchor {
    display: flex;
    align-items: center;
  }

  .user-warning-anchor-text {
    padding-right: 0.5em;
  }
`;
